import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=86358206&scoped=true"
import script from "./MyDashboard.vue?vue&type=script&lang=js"
export * from "./MyDashboard.vue?vue&type=script&lang=js"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=86358206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86358206",
  null
  
)

export default component.exports